import { find, partial, identity, uniqBy } from 'lodash'

import { getSelected, getAllPaintColors, getPrice } from 'state/customize/selectors'
import { colorKeyLookup } from 'state/customize'
import { getFilteredPutters } from 'state/findputter'
import * as helpers from './helpers'
import * as validation from './validation'

/*
 * This file contains top-level methods for building VMs for each view in the app.
 * All functions which build component pieces of those VMs should be in ./helpers
 */

export function getFinishVM(state) {
  const paintFill = helpers.getOptionVM(state, 'paintFill', true);
  const finish = helpers.getOptionVM(state, 'finish');
  const restoration = helpers.getOptionVM(state, 'restorationType');
  const buyAPutter = helpers.getOptionVM(state, 'buyAPutter');

  const grip = getSelected(state, 'grip');
  const headCover = getSelected(state, 'headCover');

  //modify paintFill options
  let options = [];
  let paintFillOptions = [];
  //TODO: Leave out 'repaint to original' for now, remove from CMS? Also, rename 'Select Colors' label, do in CMS?
  paintFillOptions = paintFill.options.filter(paintFill => (paintFill.label !== 'Repaint to Original'))
    .map(paintFill => {
      let label = paintFill.label;
      if(paintFill.label === 'Select Colors')
      {
        label = 'New Paintfill';
      }
      return {
        label: label,
        id: paintFill.id,
        price: paintFill.price,
        type: 'paintFill',
      };
    });
  options = paintFillOptions;

  
  let restorationOptions = {};
  
  if(restoration.options.length > 0)
  {
    restorationOptions = restoration.options.map(restoration => {
      return {
        label: restoration.label,
        id: restoration.id,
        price: restoration.price,
        type: 'restorationType',
      };
    });
    options = options.concat(restorationOptions);
  }

  let selected = {};
  if (restoration.selected)
  {
    selected = restorationOptions.filter(restorationOption => (restorationOption.id === restoration.selected.id))[0];
  }
  else if (paintFill.selected)
  {
    selected = paintFillOptions.filter(paintFillOption => (paintFillOption.id === paintFill.selected.id))[0];
  }
  else
  {
    selected = null;
  }
  let vm = {
    options,
    selected,
    finish,
    buyAPutter,
  }
  
  vm.validation = validation.validateFinishVM(state, vm);
  return vm;
} 

export function getSpecsVM(state) {
  const hasWeightEngraving = state.putter.hasWeightEngraving;
  const weight = helpers.getWeightVM(state);
  const hasWeights = !!weight.weights.length;
  const hasTopWeights = state.putter.hasTopWeights;
  const topWeight = (hasTopWeights) ? helpers.getWeightVM(state, true) : {};
  const length = helpers.getOptionVM(state, 'length');
  const restoration = getSelected(state, 'restorationType');
  const reshaft = helpers.getOptionVM(state, 'reshaft');
  const buyAPutter = helpers.getOptionVM(state, 'buyAPutter');
 
  
  
  let desiredLengthRequired = (reshaft != null && reshaft.selected != null && reshaft.selected.price > 0) || (restoration != null && restoration.price > 0);
  
  if(desiredLengthRequired) {
	  console.log('Len Options:');
	  console.log(length.options);
	  
	  var filteredOptions = length.options.filter((opt) => opt.label != 'Keep As Is');
	  length.options = filteredOptions;
  }
  
  if((restoration && restoration.price > 0) || (length.selected && length.selected.reshaftRequired))
  {
    //if 'add restoration' (id: 14) selected or length selected requires a reshaft, then remove 'Reuse shaft' (id: 13) option
    reshaft.options = reshaft.options.filter(reshaftOption => reshaftOption.id !== 13);
  }
  
  let vm = {
    hasWeightEngraving,
    weight,
    hasWeights,
    hasTopWeights,
    topWeight,
    desiredLength: helpers.getOptionVM(state, 'desiredLength'),
    length,
    loft: helpers.getOptionVM(state, 'loft'),
    lie: helpers.getOptionVM(state, 'lie'),
    reshaft,
    restoration,
    buyAPutter,
	desiredLengthRequired
  } 
  vm.validation = validation.validateSpecsVM(state, vm);

  return vm;
}

function getBackFaceVM(state, paramsList, isConfirm) {
  const paintFillLocations = paramsList
    .filter(k => helpers.isPaintfillArea(k))
    .map(k => helpers.getPaintVM(state, k))
    .filter(identity)
    .sort((a,b) => a.loc.rank - b.loc.rank)
    ;
  const initials = state.putter.initialsLocation
    .filter(i => paramsList.indexOf(i.paintFillKey) > -1)  
    .map(partial(helpers.getInitialsVM, state))
    ;
  const stampsLocations = state.putter.stampLocation
    .filter(i =>
      paramsList.indexOf(i.parameterKey) > -1 ||
      paramsList.indexOf(i.paintFillKey) > -1 
    )
    .map(partial(helpers.getStampVM, state))
    ;
  const paintFill = getSelected(state, 'paintFill');
  const buyAPutter = helpers.getOptionVM(state, 'buyAPutter');
  const paintFillPrice = helpers.getPaintFillPrice();
  let vm = {
    paintFillLocations, 
    initials,
    stampsLocations,
    paintFill,
    buyAPutter,
	paintFillPrice
  }
  
  vm.validation = validation.validateBackFaceVM(state, vm, isConfirm)
  return vm;
}
export function getFaceVM(state, isConfirm) {
  const faceStampOrInitialsOnly = state.putter.faceStampOrInitialsOnly;
  let vm = getBackFaceVM(state, state.putter.faceSoleImageParameters, isConfirm);
  vm.faceStampOrInitialsOnly = faceStampOrInitialsOnly;
  return Object.assign({},
    helpers.getPaintSummaryProps(state), 
    vm
  );
}
export function getBackVM(state, isConfirm) {
  return Object.assign({},
    helpers.getPaintSummaryProps(state), 
    getBackFaceVM(state, state.putter.backCavityImageParameters, isConfirm)
  );
}
export function getTopVM(state, isConfirm) {
  const paintFillLocations = [
    ...state.putter.existingTopLineParameters,
    ...state.putter.playerProfileImageParameters
    ]
    .map(k => helpers.getPaintVM(state, colorKeyLookup[k] || k))
    .filter(identity)
    ;
  const flangeLinePaintFillLocations = [
    ...state.putter.existingFlangeLineParameters,
    ]
    .map(k => helpers.getPaintVM(state, colorKeyLookup[k] || k))
    .filter(identity)
    ;
  const paintFill = getSelected(state, 'paintFill');
  const buyAPutter = helpers.getOptionVM(state, 'buyAPutter');
  const paintFillPrice = helpers.getPaintFillPrice();
  let vm = Object.assign(
    {
      paintFillLocations: [...paintFillLocations, ...helpers.mergeLinePaintVMs(flangeLinePaintFillLocations)],
      flangeLines: helpers.getLineVM(state, 'flangeLine'),
      topLines: helpers.getLineVM(state, 'topLine'),
      sightDots: helpers.getLineVM(state, 'sightDot'),
      paintFill,
      buyAPutter,
	  paintFillPrice
    }, 
    helpers.getPaintSummaryProps(state), 
  );

  vm.validation = validation.validateTopVM(state, vm, isConfirm);
  return vm;
}

export function getAccessoriesVM(state) {
  let grip = helpers.getOptionVM(state, 'grip');
  let shaftBand = helpers.getOptionVM(state, 'shaftBand'); 
  let headCover = helpers.getOptionVM(state, 'headCover');

  const buyAPutter = helpers.getOptionVM(state, 'buyAPutter');
  if (!buyAPutter.selected){ 
    shaftBand.options = [{id:0, label:"NONE"}, ...shaftBand.options];
    headCover.options = [{id:0, label:"NONE"}, ...headCover.options];
  }

    //filter out shaft rings for graphite shaft
    if (state.instance.reshaft && state.putter.reshaft) {
        let reshaftCheck = state.instance.reshaft;
        let reshaftObj = state.putter.reshaft.find(item => item.id === reshaftCheck);
        if (reshaftObj && reshaftObj.label.toLowerCase().includes("graphite")) {
            let opts2 = shaftBand.options.filter(item => !item.label.includes('Ring'));
            shaftBand.options = opts2;
        }
    }

  const gripWrap = helpers.getOptionVM(state, 'gripWrap');
  const length = getSelected(state, 'length');
  const loft = getSelected(state, 'loft');
  const lie = getSelected(state, 'lie');
  const reshaft = getSelected(state, 'reshaft');
  const colorFilters = state.putter.colorFilters || [];
  let gripRequired = (shaftBand.selected && shaftBand.selected.gripRequired)
    || (headCover.selected && headCover.selected.gripRequired)
    || (length && length.gripRequired)
    || (loft && loft.gripRequired)
    || (lie && lie.gripRequired)
    || (reshaft && reshaft.gripRequired)
    || (buyAPutter && buyAPutter.selected)
    ;
  if(gripRequired)
  {
    //remove reuse grip option
    grip.options = grip.options.filter(gripOption => gripOption.sku !== 'REUSE');
  }
  let vm = {
    grip,
    gripRequired,
    shaftBand,
    headCover,
    buyAPutter,
    gripWrap,
    colorFilters,
    length,
    loft,
    lie,
  }
  vm.validation = validation.validateAccessoriesVM(state, vm);
  return vm;
} 

export function getAuthenticationVM(state) {
  //const vm = helpers.getOptionVM(state, 'authentication');
  let vm = { 
    ...helpers.getOptionVM(state, 'authentication'),
  }

  vm.validation = validation.validateAuthenticationVM(state, vm);
  return vm;
} 

//For 17712, which states to allow users to leave auth page even if it is invalid. 
export function getAuthenticationPageVM(state) {
  let vm = { 
    ...helpers.getOptionVM(state, 'authentication'),
  }

  vm.validation = { 'valid' : true };
  return vm;
} 

export function getInsuranceVM(state){
  let vm = {
    ...helpers.getInsuranceVM(state), 
  }
  vm.validation = {'valid' : true};
  return vm; 
}

export function getConfirmVM(state) {
  const finish = getFinishVM(state);
  const face = getFaceVM(state, true);
  const back = getBackVM(state, true);
  const top = getTopVM(state, true);
  const specs = getSpecsVM(state);
  const accessories = getAccessoriesVM(state);
  const auth = getAuthenticationVM(state);
  const price = getPriceVM(state);
  const insurance = getInsuranceVM(state);
  let vm = {
    finish,
    face,
    back,
    top,
    specs,
    accessories,
    auth,
    price,
    insurance,
  }
  vm.valid = (face.validation.valid && back.validation.valid && top.validation.valid
    && specs.validation.valid && accessories.validation.valid && auth.validation.valid
    && insurance.validation.valid);
  return vm;
}

export function getReplacementPaintfillVM(state) {
  if (state.replacementPaintFill) {
    const paints = getAllPaintColors(state);
    return { 
      color:find(paints, { id: state.replacementPaintFill.color }),
      location: state.replacementPaintFill.location
    }
  }
  return null; 
} 

export function getPaintSummaryVM(state) {	
  let paints = helpers.getPaletteColors(state);
  return paints;
}

export function getFindPutterVM(state) {
  return {
    filter: state.findputter.filter,
    category: state.findputter.category,
    loading: state.findputter.loading,
    putters: getFilteredPutters(state.findputter),
    showBuyTab: !!find(state.findputter.putters, { 'buy_a_putter': true })
  }
}

export function getPriceVM(state) {
  const minPrice = helpers.getOptionVM(state, 'minPrice').options;

  let price = getPrice(state);
  let isMinPrice = false;
  if(price < minPrice)
  { 
    isMinPrice = true; 
    price = minPrice;
  }

  let buyLink = 'confirm';
  
  return {
    total: price,
    buyLink,
    isMinPrice,
  }
}

export function getPackageVM(state) {
  return {
    packages: helpers.getOptionVM(state, 'packages').options,
  }
}